<template>
    <div id="Container_ItemsReceivedListFilterRep">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="$t('ItemsReceivedListRep.ReportTitle')" />  
            </b-col>
        </b-row>
        <b-row>
            <div class="col-sm-12 col-md-12 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group"  dir="ltr">
                        <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                            @keyup.enter="SearchItemsReceived" />

                        <div class="input-group-append">
                            <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'" v-on:click="SearchItemsReceived">
                            </MdButton>
                        </div>
                    </div>
                </div>
            </div>
        </b-row>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.datefrom')"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'DateFrom'"
                    v-model="DateFrom"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-on:change="DateFromChange($event)"
                    v-bind:OnPressEnter="SearchItemsReceived"           
                >                                     
                </MdEdit>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.dateTo')"
                    v-bind:TypeProp="'date'" 
                    v-bind:Name="'DateTo'"
                    v-model="DateTo"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-on:change="DateToChange($event)"          
                    v-bind:OnPressEnter="SearchItemsReceived"
                    >                                     
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('ePharmacyItemsReceived.BatchNo')"
                    v-bind:Name="'Program'"
                    v-bind:TypeProp="'text'"       
                    v-model="Batchno"
                    v-bind:Id="'input_dprogram_id'"
                /> 
            </b-col>     
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Options="pharmacyLocations"
                    v-bind:Model="locationModel"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="true"
                    :Input="ChangeDropDownLocation"
                    v-bind:Name="'note_types_select'"
                    id="note_types_select"
                />									
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('ePharmacyItemsReceived.InvoiceNumber')"
                    v-bind:Name="'invoiceNumber'"
                    v-model="InvoiceNumber"
                    v-bind:TypeProp="'text'"       
                    v-bind:Id="'input_invoiceNumber'"
                    :Max="'30'"
                /> 
            </b-col>
             <b-col lg="3" md="3" sm="12">         
                <MdSelect
                v-bind:Label="$t('Medication.Drugs')"
                v-bind:Options="DrugCodeList"
                v-bind:Model="DrugsCodeModel"
                v-bind:FieldDescription="'drugname'"
                v-bind:FieldCode="'drugCode'"
                v-bind:Multiple="true"             
                :Input="ChangeDropDownDrugs"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('ePharmacyItemsReceived.Vendor')"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'vendorcode'"
                    v-bind:Options="VendorCodeList"
                    v-bind:Model="VendorModel"
                    v-bind:Multiple="true"
                    :Input="ChangeDropDownVendor"
                    v-bind:Name="'vendor_select'"
                    id="vendor_select"
                />									
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('ePharmacyItemsReceived.InvoiceNumber')"
                    v-bind:Name="'PurcharseNumber'"
                    v-model="PurcharseNumber"
                    v-bind:TypeProp="'text'"       
                    v-bind:Id="'input_invoiceNumber'"
                    :Max="'30'"
                /> 
            </b-col>
        </b-row>
        <b-row>
           <b-col md="12">
                <div class="mt-3 text-right">
                    <button 
                        v-on:click="SearchItemsReceived"
                        type="button"
                        class="btn btn-primary btn-login mx-2"												
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
        </b-row>    
       <div class="row">
        <div class="col-md-12">
        
          <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                      v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
          <div class="row">
            <div class="col-md-12">
              <MdTable 
                v-bind:fields="fields"
                v-bind:items="items"
                v-bind:totalRows="totalRows"
                v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                v-bind:currentPage="currentPage"
                v-bind:perPage="perPage"
                v-bind:pageOptions="pageOptions"
                v-bind:refTable="refTable"
                :pageChanged="pageChanged"
                :perPageFunction="PerPageFunction">
              </MdTable>
            </div>
          </div>
        </div>
      </div>
      <div class="space-actions"></div>
        
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="reportList"
                v-bind:Name="'btn_ReportList'"/>
            <MdButton
                v-bind:Label="$t('Shared.Report')"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="onClickShowReport"
                v-bind:Name="'btn_Print'"/>

            <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
                <b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
                <b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
                <b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
            </b-dropdown>   
        </div>

        <DxPopup
            :visible="isReportVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('ItemsReceivedListRep.ReportTitle')"
            @hidden="onHiddenReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
        >
        <ReportViewer
            ref="reportItemsReceivedListFilters"
            :ReportName="'ItemsReceivedList'"
            :ReportTitle="$t('ItemsReceivedListRep.ReportTitle')"
            :IsAnAPIReport="true"
            />
        </DxPopup>

        <CSVExportHelper
            ref="csvExportHelper"
            v-bind:conformSubject="$t('ItemsReceivedListRep.ReportTitle')"
            v-bind:sendEmailAPI="'/ItemReceivedHeaders/email'"
            v-bind:exportCsvAPI="'/ItemReceivedHeaders/exportCSV'"
        >    
        </CSVExportHelper>
    </div>
</template>

<script>
import Vue from 'vue'
import DBFunctions from '@/common/DBFunctions.js'
import { DxPopup } from 'devextreme-vue/popup';
import ShowMessage from '@/components/messages/ShowMessage.js';
import ePharmacyItemsReceivedService from '@/services/epharmacyitemsreceived.service';
import ePharmacyLocationsService from '@/services/epharmacylocation.service';
import Utils from "@/common/utils";
import DrugService from '@/services/drug.service'
import UtilsService from '@/services/utils.service'
import { EventBus } from '@/event-bus.js';


export default Vue.extend({
    name: 'ePharmacyItemsReceivedList',
    mixins: [DBFunctions, ShowMessage],
    components: { DxPopup },
    data() {
        return {
            fields: [
                { key: 'BATCHNO', sortable: true, label: this.$t('ePharmacyItemsReceivedList.BatchNo'), class: 'text-rigth' },       
                { key: 'RECEIVEDDATE', sortable: true, label: this.$t('ePharmacyItemsReceivedList.Date'), class: 'text-rigth' }, 
                { key: 'Location', sortable: true, label: this.$tc('ePharmacyItemsReceived.Location'), class: 'text-rigth' }, 
                { key: 'InvoiceNumber', sortable: true, label: this.$t('ePharmacyItemsReceivedList.InvoiceNumber'), class: 'text-rigth'},       
                { key: 'PONUMBER', sortable: true, label: this.$t('ePharmacyItemsReceivedList.PoNumber'), class: 'text-rigth' },
                { key: 'QUANTITY_RECEIVED', sortable: true, label: this.$t('ItemAvailabilityRep.QTYReceived'), class: 'text-rigth' },
                { key: 'QUANTITY', sortable: true, label: this.$t('Shared.quantity'), class: 'text-rigth' },            
                { key: 'Vendor', sortable: true, label: this.$t('ePharmacyItemsReceivedList.Vendor'), class: 'text-rigth', formatter: (value) => { return value?.name ?? ''}  },
                { key: 'COMMENTS', sortable: true, label: this.$t('ePharmacyItemsReceivedList.Comments'), class: 'text-rigth' },        
            ],
            FieldsDateArr:['dateFrom','dateTo'], 
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            items: [],
            DateFrom: null,
            DateTo: null,
            ShowMessageIsEmpty: '',
            parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize: 0
            },
              
            params: {
                Locations: "",
                DrugList:"",
                VendorList:""
            },
            DrugCodeList:[],
            VendorCodeList:[],
            pharmacyLocations: [],
            selectPlaceholder: this.$t('ClinicalNotes.SelectOptions'),
            locationModel: null,
            isReportVisible: false,
            recNoToReport: null,
            DrugsCodeModel:'',
            VendorModel:'',
            Batchno: '',
            InvoiceNumber: '',
            PurcharseNumber:'',
            refTable: 'selectableTable', 
        };
    },

    methods: {
        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
        },

        onHiddenReport() {
            this.isReportVisible = false
        },

        SearchItemsReceived(){
            this.items = []
            this.currentPage = 1;
            this.totalRows = this.items.length;
            this.parameter.PageNumber = 1;
            this.getListing();
        },

        getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_ReceiveItems'; 
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                DateFrom: this.parameter.DateFrom,
                DateTo: this.parameter.DateTo,
                LocationCodeList: this.parameter.Locations,
                DrugCodeList: this.parameter.DrugList,
                BatchNoList: this.parameter.Batchno,
                InvoiceNumber: this.parameter.InvoiceNumber,
                PurcharseNumber: this.parameter.PurcharseNumber,
                VendorCodeList: this.parameter.VendorList
            };
            
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };

            UtilsService.getExecuteSP(request)
            .then((response) => {
                if(response.status == '200' && response.data){
                    this.items = response.data;
                    
                    this.items.forEach(function(element) {
                        let { RECEIVEDDATE } = element
                        if (RECEIVEDDATE) element.RECEIVEDDATE = Utils.formatterDateToString(RECEIVEDDATE);        
                    });
                    let headerString = response.headers["x-pagination"];
                    this.Header = JSON.parse(headerString);
                    this.totalRows = this.Header.TotalCount;
                } 
            })
            .catch((error) => {
                this.showResponseErrorMessage(error);
            });
        },

        onClickClose() {
            this.isParamVisible = false;
        },

        reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
        },

        initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : null;
            
            this.parameter.DateFrom = this.DateFrom && this.DateFrom !== '' 
                ? this.DateFrom
                : '';
            this.parameter.DateTo = this.DateTo && this.DateTo !== '' 
                ? this.DateTo
                : '';
            this.parameter.PurcharseNumber = this.PurcharseNumber && this.PurcharseNumber !== '' 
                ? this.PurcharseNumber
                : '';
            this.parameter.Batchno = this.Batchno && this.Batchno !== '' 
                ? this.Batchno
                : '';
            this.parameter.VendorList = this.params.VendorList && this.params.VendorList !== '' 
                ? this.params.VendorList
                : '';
            this.parameter.Locations = this.params.Locations && this.params.Locations !== '' 
              ? this.params.Locations
              : null;
            this.parameter.InvoiceNumber = this.InvoiceNumber && this.InvoiceNumber !== '' 
                ? this.InvoiceNumber
                : '';
          },

        initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.DateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.DateTo})
            this.reportParams.push({ paramName: 'pLocations', paramValue: this.params.Locations})
            this.reportParams.push({ paramName: 'pDrugList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pVendorCodeList',paramValue: this.params.VendorList })
            this.reportParams.push({ paramName: 'pBatchNoList',paramValue: this.Batchno })
            this.reportParams.push({ paramName: 'pInvoiceNumber',paramValue: this.InvoiceNumber })
            this.reportParams.push({ paramName: 'pPurcharseNumber',paramValue: this.PurcharseNumber })
            this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
        },

        onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportItemsReceivedListFilters.buildDocument(this.reportParams)
        },

        pageChanged (page) {            
            this.currentPage = page;    
            this.getListing();     
        },

        PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();  
        },
        
        DateFromChange(value) {
            this.parameter.DateFrom = value
        },

        DateToChange(value) {
            this.parameter.DateTo = value
        },

        getPharmacyLocations() {
            const parameter ={
                PageSize: 0,
                PageNumber: 0
            }

            this.pharmacyLocations = [];
            ePharmacyLocationsService.getAll(parameter)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.pharmacyLocations = response.data;
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        getDrugs() { 
            const params = {
              SearchCriteria: '',
            }
            this.DrugCodeList = [];
            DrugService.getAll(params)
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.DrugCodeList = response.data;
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
        },

        getVendors() { 
            const params = {
                SearchCriteria: '',
                PageSize: 0,
                PageNumber: 0,
                IsActive: true
            }
            this.VendorCodeList = [];
            ePharmacyItemsReceivedService.getVendors(params)
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.VendorCodeList = response.data;
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
        },

        ChangeDropDownLocation(values){
            var locations = '';
            if (values && values.length > 0) {
                locations = values.map(x => x.code).join(',');
            }
            this.params.Locations = locations; 
        },

        ChangeDropDownDrugs(values) {
            var drugList = '';
            if (values && values.length > 0) {
                drugList = values.map(x => x.drugCode).join(',');
            }
            this.params.DrugList = drugList; 
        },

        ChangeDropDownVendor(values) {
            var vendorList = '';
            if (values && values.length > 0) {
                vendorList = values.map(x => x.vendorcode).join(',');
            }
            this.params.VendorList = vendorList; 
        },

        handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
        },

        handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('ItemsReceivedList', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('ItemsReceivedList', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
        },
    },

    async created() {
        
    },

    async mounted(){
        this.getDrugs();
        this.getPharmacyLocations();
        this.getVendors();
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
    }
 })
</script>